The input parameter for retrieving a single position not posted reason.
